import { urlBackoffice } from './backoffice';

/**
 * Entorno por defecto (DEV).
 *
 * Es el que usa la imagen Docker de dev: el CI buildea esa rama con la
 * configuración `development`, que no aplica `fileReplacements` (ver
 * `.gitlab-ci.yml`). `qa` buildea con `qa` y usa `environment.qa.ts`; `main`
 * buildea con `production` y usa `environment.production.ts`.
 */
export const environment = {
  production: false,

  /**
   * Las llamadas van siempre a `/api` (mismo origen, sin CORS). Quién atiende
   * ese path depende del entorno:
   * - dev con `npm start`: proxy de `ng serve` → `https://api.dev.phindi.com`
   *   (proxy.conf.json, declarado en angular.json).
   * - dev con `npm run start-local`: proxy → backend NestJS en localhost:3000
   *   (proxy.conf.local.json).
   * - producción: el rewrite de `/api` lo hace el vhost de infra.
   */
  apiUrl: '/api',

  /**
   * URL base del backoffice para los links del menú (FP-04). Se deriva del
   * hostname; el valor de acá es el respaldo para desarrollo local.
   */
  backofficeUrl: urlBackoffice('https://admin.dev.phindi.com'),

  /**
   * API key de Google Maps (Maps JavaScript API). Ver documento de
   * estimación §7 (BE-01): requiere proyecto en Google Cloud con
   * facturación activa y key restringida por dominio.
   * Sin key, la vista de mapa muestra un aviso de configuración.
   *
   * FP-51 — key del entorno DEV. Va acá y no en `environment.production.ts`
   * porque éste es el archivo que usa la imagen Docker de dev: el CI buildea
   * esa rama con la configuración `development`, que no aplica
   * `fileReplacements` (QA y producción tienen su propia key). Como toda
   * key de la Maps JavaScript API viaja en el bundle; lo que la protege es la
   * restricción por dominio, no el secreto.
   */
  googleMapsApiKey: 'AIzaSyD6hPtj474i_lfXIeJpSU8stief8vpCIlE',

  /**
   * Map ID de Google Maps. Requerido por los AdvancedMarkerElement (pines
   * con precio). Map ID de DEV (proyecto de Google Cloud de la key de arriba),
   * vectorial y con las capas de nivel 1 y 2 (Área administrativa) habilitadas
   * en su estilo: las usa el contorno de zona (FE-04, Data-Driven Styling).
   * QA tiene el suyo en `environment.qa.ts`. Los estilos se cambian en la
   * consola de Google Cloud, sin redeploy.
   */
  googleMapsMapId: '60d7298563a6e42b38fe55c3',

  /**
   * Interruptor del contorno de zona en el mapa del buscador (FE-04): con una
   * sola zona buscada, pinta su partido / departamento, CABA o la provincia y
   * encuadra el contorno entero (ver `zona-partido.ts`). En `false` el mapa
   * sólo encuadra la zona, como antes del contorno, y no le pide capas a
   * Google. Requiere las capas de nivel 1 y 2 en el estilo del Map ID. Cada
   * entorno tiene su propio interruptor.
   */
  contornoDeZonaHabilitado: false,

  /**
   * Interruptor de la búsqueda por provincia: el autocompletado del buscador
   * sugiere "Provincia de X" (y CABA), que trae todas las propiedades de esa
   * provincia y, con el contorno prendido, la pinta entera. Necesita el
   * backend que filtra esas zonas por provincia (`provinciaDeZona`): con un
   * backend anterior, elegir una provincia trae cero resultados.
   */
  busquedaPorProvinciaHabilitada: false,
};
